import __request__ from "routing/request";
export function count(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.failure/failures/count", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
